import React from 'react';

import { DynamicProductTable } from '../_dynamic';
import { ProductTableProps } from '../_dynamic/constants';

import { tableHead } from './constants';
import ProductItem from './item';

export const RequiredMarginTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={4}
      tabletRows={1}
      mobileFields={[
        { key: 'clientName', label: 'Cliente' },
        { key: 'requiredMarginValue', label: 'Requerido' },
        { key: 'totalGuaranteeValue', label: 'Em Garantia' },
        { key: 'marginBalanceValue', label: 'Saldo' },
      ]}
    />
  );
};
